import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Spin } from "antd";
import { Toast } from "react-bootstrap";
import DualListBox from "../../../../duallistBox";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import Select from 'react-select'
type User = {
  bio?: string | null;
  phone_number?: string | null;
  states?: Array<number>;
  zones?: Array<number>;
  branches?: Array<number>;
  is_idealtime?: boolean;
};

interface State {
  id: number;
  name: string;
}

interface Zone {
  id: number;
  name: string;
}

interface Branch {
  id: number;
  name: string;
}

interface ServiceDivision {
  id: number;
  name: string;

}

interface BuildingCategory {
  id: number;
  name: string;
}

interface Option {
  value: number;
  label: string;
}

interface Users {
  id: number;
  username: string;
}


const AddBranchAssignment = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const jwtToken = Cookies.get("authToken");
  const { webApi, userPermissions } = useUserPermissions();
  const [profileRecord, setProfileRecord] = useState<User | null>(null);
  const [chosenStates, setChosenStates] = useState<number[]>([]);
  const [chosenServiceDivisions, setChosenServiceDivisions] = useState<number[]>([]);
  const [chosenZones, setChosenZones] = useState<number[]>([]);
  const [chosenBranches, setChosenBranches] = useState<number[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [zones, setZones] = useState<Zone[]>([]);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [serviceDivisions, setServiceDivisions] = useState<ServiceDivision[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [idealTime, setIdealTime] = useState(true);
  const [toastMessage, setToastMessage] = useState("");
  const [buildingCategories, setBuildingCategories] = useState<BuildingCategory[]>([]);
  const [chosenBuildingCategories, setChosenBuildingCategories] = useState<number[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [users, setUsers] = useState<Users[]>([]);
  const [selectedUser, setSelectedUser] = useState<Option | null>(null);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchBuildingCategories = async () => {
    const response = await fetch(
      `${webApi}/user/building_category_dropdown/`,
      options
    );
    const data = await response.json();

    // Map API response to only id and name
    const formatted = data.map((item: { building_category_id: any; name: any; }) => ({
      id: item.building_category_id,
      name: item.name
    }));

    setBuildingCategories(formatted);
  };

  const fetchAgents = async () => {
    const response = await fetch(
      `${webApi}/employees/employee_team_members_dropdown/`,
      options
    );
    const data =  await response.json();
    setUsers(data);
  };


  const fetchStateData = async () => {
    const response = await fetch(
      `${webApi}/user/state_dropdown/?building_category_ids=${chosenBuildingCategories}`,
      options
    );
    return await response.json();
  };

  const fetchServiceDivisions = async () => {
    const response = await fetch(
      `${webApi}/employees/teacher_service_division_dropdown/`,
      options
    );
    return await response.json();
  };

  const handleChange = (option: Option | null) => {
    setSelectedOption(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };

  const handleUserChange = (option: Option | null) => {
    setSelectedUser(option);
    if (option) {
      console.log('Selected ID:', option.value);
    }
  };

  const fetchZonesData = async () => {
    const response = await fetch(
      `${webApi}/user/get_zones_dropdown/${chosenStates}/`,
      options
    );
    return await response.json();
  };

  const fetchBranchesData = async () => {
    const response = await fetch(
      `${webApi}/user/get_branches_dropdown/${chosenZones}/`,
      options
    );
    return await response.json();
  };

  const fetchUserProfileData = async () => {
    const response = await fetch(`${webApi}/employees/employee_calling_branch_assignment/${id}/`, options);
    return await response.json();
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [serviceDivisions] = await Promise.all([
        // fetchStateData(),
        // fetchUserProfileData(),
        fetchServiceDivisions(),
      ]);

      // const states = stateData.results.map(
      //   (state: { state_id: number; name: string; is_active: boolean }) => ({
      //     id: state.state_id,
      //     name: state.name,
      //   })
      // );
      setServiceDivisions(serviceDivisions);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!checkPermission("add_employeecallingbranchassignment", "employeecallingbranchassignment")) {
      navigate(routes.crmLandingPage);
    } else {
      fetchData();
      fetchServiceDivisions()
      fetchBuildingCategories();
      fetchStateData();
      fetchAgents();
    }
  }, [userPermissions]);

  useEffect(() => {
    const fetchStates = async () => {
      if (chosenBuildingCategories.length > 0) {
        const statesData1 = await fetchStateData();
        const statesData = statesData1;
        const states = statesData.map((zone: any) => ({
          id: zone.state_id,
          name: zone.name,
        }));
        setStates(states);
      } else {
        // Clear zones and branches if no states are selected
        setStates([]);
        setChosenStates([]);
        setZones([]);
        setChosenZones([]);
        setBranches([]);
        setChosenBranches([]);
      }
    };
    fetchStates();
  }, [chosenBuildingCategories]);

  useEffect(() => {
    const fetchZones = async () => {
      if (chosenStates.length > 0) {
        const zonesData1 = await fetchZonesData();
        const zonesData = zonesData1.results;
        const zones = zonesData.map((zone: any) => ({
          id: zone.zone_id,
          name: zone.name,
        }));
        setZones(zones);
      } else {
        // Clear zones and branches if no states are selected
        setZones([]);
        setChosenZones([]);
        setBranches([]);
        setChosenBranches([]);
      }
    };
    fetchZones();
  }, [chosenStates]);

  useEffect(() => {
    const fetchBranches = async () => {
      if (chosenZones.length > 0) {
        const branchesData1 = await fetchBranchesData();
        const branchesData = branchesData1.results;
        const branches = branchesData.map((branch: any) => ({
          id: branch.branch_id,
          name: branch.name,
        }));
        setBranches(branches);
      } else {
        // Clear branches if no zones are selected
        setBranches([]);
        setChosenBranches([]);
      }
    };
    fetchBranches();
  }, [chosenZones]);

  const handleProfileSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setIsLoading1(true);
    e.preventDefault();

    const updatedProfileRecord = {
      ...profileRecord,
      state: chosenStates,
      zone: chosenZones,
      branch: chosenBranches,
      service_division: selectedOption ? selectedOption.value : null,
      building_category: chosenBuildingCategories,
      calling_agent: selectedUser ? selectedUser.value : null,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(updatedProfileRecord),
    };

    try {
      const url = `${webApi}/employees/employee_calling_branch_assignment/`;
      const response = await fetch(url, requestOptions);

      if (!response.ok) {
        const errorData = await response.json();
        setToastMessage(errorData.phone_number);
        setShowSolidDangerToast(true);
        throw new Error(errorData.detail || "Failed to update profile");
      }

      const data = await response.json();
      console.log("Profile updated successfully:", data);
      navigate(routes.employeeBranchAssignment);
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setIsLoading1(false);
    }
  };

  const availableStates = states.filter(
    (state) => !chosenStates.includes(state.id)
  );
  const availableZones = zones.filter((zone) => !chosenZones.includes(zone.id));
  const availableBranches = branches.filter(
    (branch) => !chosenBranches.includes(branch.id)
  );

  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setProfileRecord({ ...profileRecord, [name]: value === "true" });
  };

  const options2: Option[] = serviceDivisions.map(user => ({
    value: user.id,
    label: user.name,
  }));

  const usersDropdownOptions: Option[] = users.map(user => ({
    value: user.id,
    label: user.username,
  }));

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Employee Branch Assignment</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.crmLandingPage}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.employeeBranchAssignment}>Branch Assignment</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Employee Branch Assignment</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "15px",
                }}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      height: "100vh",
                      paddingTop: "20px",
                    }}
                  >
                    <Spin /> {/* Display loader while loading */}
                  </div>
                ) : (
                  <div className="card-body">
                    <form onSubmit={handleProfileSubmit}>
                      <div className="modal-body light-violet-bg">
                        <div style={{ display: "flex", flexWrap: "nowrap", alignItems: "flex-start" }}>
                          <div style={{ width: "35%",marginRight:"20px" }}>
                            <label className="form-label">Agent</label>
                            <Select
                              value={selectedUser}
                              onChange={handleUserChange}
                              options={usersDropdownOptions}
                              placeholder="Select Agent"
                            />
                          </div>
                          <div style={{ width: "35%" }}>
                            <label className="form-label">Service Division</label>
                            <Select
                              value={selectedOption}
                              onChange={handleChange}
                              options={options2}
                              placeholder="Select Service Division"
                            />
                          </div>
                          {/* <div
                            className="form-group me-3"
                            style={{
                              flex: 1,
                              marginRight: "45px",
                              marginBottom: "3px",
                            }}
                          >
                            <label className="form-label">Phone number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone_number"
                              placeholder="Phone Number"
                              inputMode="numeric"
                              pattern="\d{10}"
                              maxLength={10}
                              minLength={10}
                              value={profileRecord ? profileRecord.phone_number || "" : ""}
                              style={{ width: "100%" }}
                              onChange={(e) =>
                                setProfileRecord({
                                  ...profileRecord,
                                  phone_number: e.target.value,
                                })
                              }
                              onBlur={(e) => {
                                const phone = e.target.value;
                                if (!/^\d{10}$/.test(phone)) {
                                  setToastMessage("Please enter a valid 10-digit phone number.");
                                  setShowSolidDangerToast(true);
                                }
                              }}
                            />

                          </div> */}
                          {/* <div
                            className="radio-group-item"
                            style={{
                              flex: 1,
                              marginBottom: "9px",
                              padding: "10px",
                              borderRadius: "5px",
                            }}
                          >
                            <label className="form-label">Is Ideal Time Needed</label>
                            <div>
                              <input
                                type="radio"
                                id="is_superuser_yes"
                                name="is_idealtime"
                                value="true"
                                checked={profileRecord?.is_idealtime === true}
                                onChange={handleRadioChange}
                              />
                              <label
                                htmlFor="is_superuser_yes"
                                style={{
                                  marginLeft: "5px",
                                  marginRight: "15px",
                                  cursor: "pointer",
                                }}
                              >
                                Yes
                              </label>
                              <input
                                type="radio"
                                id="is_superuser_no"
                                name="is_idealtime"
                                value="false"
                                checked={profileRecord?.is_idealtime === false}
                                onChange={handleRadioChange}
                              />
                              <label
                                htmlFor="is_superuser_no"
                                style={{
                                  marginLeft: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                No
                              </label>
                            </div>
                          </div> */}
                        </div>
                        {/* <div className="form-group dual-list-box-container">
                          <label
                            className="form-label"
                            style={{ marginTop: "3px" }}
                          >
                            Service Division
                          </label>
                          <DualListBox
                            options={serviceDivisions}
                            selected={chosenServiceDivisions
                              .map((id) =>
                                serviceDivisions.find((state) => state.id === id)
                              )
                              .filter(
                                (state): state is State => state !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (state) => state.id
                              );
                              setChosenServiceDivisions(selectedIds);
                            }}
                          />
                        </div> */}

                        <div className="form-group dual-list-box-container">
                          <label
                            className="form-label"
                            style={{ marginTop: "3px" }}
                          >
                            Building Category
                          </label>
                          <DualListBox
                            options={buildingCategories}
                            selected={chosenBuildingCategories
                              .map((id) =>
                                buildingCategories.find((state) => state.id === id)
                              )
                              .filter(
                                (state): state is State => state !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (state) => state.id
                              );
                              setChosenBuildingCategories(selectedIds);
                            }}
                          />
                        </div>


                        <div className="form-group dual-list-box-container">
                          <label
                            className="form-label"
                            style={{ marginTop: "3px" }}
                          >
                            States
                          </label>
                          <DualListBox
                            options={availableStates}
                            selected={chosenStates
                              .map((id) =>
                                states.find((state) => state.id === id)
                              )
                              .filter(
                                (state): state is State => state !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (state) => state.id
                              );
                              setChosenStates(selectedIds);
                            }}
                          />
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label className="form-label">Zones</label>
                          <DualListBox
                            options={availableZones}
                            selected={chosenZones
                              .map((id) => zones.find((zone) => zone.id === id))
                              .filter(
                                (zone): zone is Zone => zone !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (zone) => zone.id
                              );
                              setChosenZones(selectedIds);
                            }}
                          />
                        </div>
                        <div className="form-group dual-list-box-container">
                          <label className="form-label">Branches</label>
                          <DualListBox
                            options={availableBranches}
                            selected={chosenBranches
                              .map((id) =>
                                branches.find((branch) => branch.id === id)
                              )
                              .filter(
                                (branch): branch is Branch =>
                                  branch !== undefined
                              )}
                            onChange={(selected) => {
                              const selectedIds = selected.map(
                                (branch) => branch.id
                              );
                              setChosenBranches(selectedIds);
                            }}
                          />
                        </div>
                      </div>
                      <div className="modal-footer">
                        <Link
                          className="btn btn-primary"
                          to={routes.employeeBranchAssignment}
                          style={{
                            backgroundColor: "lightcoral",
                            color: "white",
                            marginRight: "5px",
                          }}
                        >
                          Cancel
                        </Link>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          disabled={isLoading}
                        >
                          {" "}
                          {isLoading1 ? (
                            <i className="spinner-border spinner-border-sm"></i>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                )}
                <Toast
                  show={showSolidDangerToast}
                  onClose={handleSolidDangerToastClose}
                  id="solidDangerToast"
                  className="colored-toast bg-danger text-fixed-white"
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                  style={{
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    zIndex: 1050,
                  }}
                >
                  <Toast.Body>{toastMessage}</Toast.Body>
                </Toast>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBranchAssignment;
